import { Div, Collection, Link } from "@tblabs/truffle";


export class Swaper<T> extends Div
{
    constructor(collection: Collection<T>, item: T)
    {
        super();
        this.Style("display: flex; align-items: center; justify-content: flex-end; gap: 12px; width: 82px; margin-left: 16px;");

        this.Append(
            collection.CanSwapUp(item) && new Link("▲").OnClick(() => collection.SwapUp(item)),
            collection.CanSwapDown(item) && new Link("▼").OnClick(() => collection.SwapDown(item)),
            new Link("×").FontSize(28).OnClick(() => collection.Remove(item))
        );
    }
}
